import request from '../utils/request';
//首页

//展品推荐
export function getrecommendedExhibits(data) {
    return request({
        url: '/onlineExhibition/recommendedExhibits',
        method: 'get',
        params: {
            pageNo: 1,
            pageSize: 6,
            exhibitsType: data,
        },
    });
};


//展商推荐
export function getrecommendedExhibitor() {
    return request({
        url: '/onlineExhibition/recommendedExhibitor',
        method: 'get',
        params: {
            pageNo: 1,
            pageSize: 8,
        },
    });
};


//直播推荐
export function getexhibitionLive() {
    return request({
        url: '/onlineExhibition/exhibitionLive',
        method: 'get',
        params: {
            pageNo: 1,
            pageSize: 20,
        },
    });
};


//精彩活动
export function getActivities(data) {
    return request({
        url: '/onlineExhibition/excitingActivities',
        method: 'get',
        params: {
            pageNo: 1,
            pageSize: 20,
        },
    });
};

// 通栏广告位
export function getbannerSlot() {
    return request({
        url: '/onlineExhibition/bannerSlot',
        method: 'get',
    });
};


//收藏接口
export function addCollect(data) {
    return request({
        url: '/onlineExhibition/addCollect',
        method: 'get',
        params: data,
    });
}
